module.exports = __webpack_public_path__ + "static/media/trees.d05fe6e2.svg";